module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/paypal-logo-7622c43a5f1cd570d73dfeba325b725a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/paypal-logo.svg
// module id = vlHt
// module chunks = 24